<template>
  <div>
    <button
      type="button"
      v-for="button in buttonsIterator"
      :disabled="button.disabled"
      :key="button.id"
      :class="'widget-button-right btn ' + button.class"
      @click="$root.$emit(button.eventName)"
    >
      {{ button.text }}
    </button>
  </div>
</template>

<script>
import WidgetButtonsEnum from '../enums/WidgetButtonsEnum'

export default {
  name: 'SignWidgetButtons',

  props: {
    buttons: {
      type: Array,
      default: () => ([WidgetButtonsEnum.closeButton])
    },
    mediator: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    innerButtons: []
  }),

  computed: {
    buttonsIterator () {
      let buttons = this.buttons
      if (this.innerButtons?.length) {
        buttons = this.innerButtons
      }

      return buttons
    }
  },

  methods: {
    setButtons (buttons) {
      this.innerButtons = buttons
    }
  }
}
</script>
